<template>
  <v-stepper-step v-bind="$props" v-on="$listeners">
    <span class="mb-2">{{ title }}</span>
    <small>{{ subtitle }}</small>
  </v-stepper-step>
</template>

<script>
import { VStepperStep } from 'vuetify/lib'
export default {
  name: 'StepperStep',
  extends: VStepperStep,
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
}
</script>
